module.exports = __webpack_public_path__ + "img/paas.59cb314.svg";